import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import './index.less';

import { MessageRole, SearchMessageModel, SearchThreadModel } from '../../../../../../gamma-api';
import { alertsSelectorAdd } from '../../../../../recoil';
import { IMessageListItem, MessageListItemDirection } from '../../../../../components/MessageListItem';
import { LARGE_PAGE_SIZE } from '../../../../../constants';
import { defaultApi } from '../../../../../apis';
import MessageList from '../../../../../components/MessageList';
import { getChatMessageTextContent } from '../../../../../utils/messageUtil';
import AssistantMessageView from '../../TestingChatTab/AssistantMessageView';
import { PROJECT_AVATAR_NAME_DEFAULT, USER_AVATAR_NAME_DEFAULT } from '../../const';

const MAIN_CLASS_NAME = 'message-list-view';
const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
const INFO_CLASS_NAME = `${MAIN_CLASS_NAME}__info`;

export interface IMessageListViewProps {
  thread?: SearchThreadModel;
}

const MessageListView: React.FC<IMessageListViewProps> = ({ thread }) => {
  const addAlert = useSetRecoilState(alertsSelectorAdd);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [messageList, setMessageList] = useState<SearchMessageModel[]>([]);
  const [selectedMessage, setSelectedMessage] = useState<SearchMessageModel>();

  const mapMessage = (message: SearchMessageModel): IMessageListItem => {
    const direction =
      message.chat_message.role === MessageRole.User
        ? MessageListItemDirection.OUTBOUND
        : MessageListItemDirection.INBOUND;

    return {
      id: message.message_id,
      senderName: direction === MessageListItemDirection.OUTBOUND ? t('Project: Testing chat: Sender name') : '',
      senderAvatar:
        direction === MessageListItemDirection.OUTBOUND ? USER_AVATAR_NAME_DEFAULT : PROJECT_AVATAR_NAME_DEFAULT,
      content: getChatMessageTextContent(message.chat_message),
      isSelected: selectedMessage?.message_id === message.message_id,
      direction,
    };
  };

  const fetchMessages = async () => {
    if (!thread) return;
    try {
      setLoading(true);
      const response = await defaultApi.searchAllMessagesSearchMessagesAllGet(
        null,
        [thread.thread_id],
        null,
        0,
        LARGE_PAGE_SIZE
      );
      setMessageList(response.data.items || []);
    } catch (err) {
      addAlert({ content: t('Failed to load messages'), type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void fetchMessages();
    setSelectedMessage(undefined);
  }, [thread]);

  const onMessageSelect = (message: IMessageListItem) => {
    const foundMessage = messageList.find((m) => m.message_id === message.id);

    if (foundMessage?.chat_message.role == MessageRole.Assistant) {
      setSelectedMessage(foundMessage);
    }
  };

  return (
    <div className={MAIN_CLASS_NAME}>
      <div className={CONTENT_CLASS_NAME}>
        <MessageList
          readonly
          loading={loading}
          messageList={messageList.map(mapMessage)}
          onMessageSelect={onMessageSelect}
        />
      </div>
      <div className={INFO_CLASS_NAME}>
        <AssistantMessageView message={selectedMessage} />
      </div>
    </div>
  );
};

export default MessageListView;
